import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official'; // Or use @highcharts/react components
import 'highcharts/modules/exporting';
import { formatNumber } from '../../../../../Common/FormatNumber';

interface ChartProps {
  title: string;
  height: number;
}

const BarChart: React.FC<ChartProps> = ({ title, height = 345 }) => {
  const [categories, setCategories] = React.useState([]);
  const [currentSales, setCurrentSales] = React.useState([]);
  const [modelSales, setModelSales] = React.useState([]);
  
  const chartComponentRef = React.useRef<HighchartsReact.RefObject>(null);
  React.useEffect(() => {
    fetch(`/dashboard/current-vs-opportunity-sales/?entity_id=${localStorage.getItem('entity_id')}`)
      .then(response => response.json())
      .then(data => 
        setTimeout(() => {
          setCategories(data.categories);
          setCurrentSales(data.current_sales);
          setModelSales(data.model_sales);
        }, 100)
      );

    const handleResize = () => {
      if (chartComponentRef.current && chartComponentRef.current.chart) {
        chartComponentRef.current.chart.reflow();
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const options: Highcharts.Options = {
        chart: {
            type: 'column',
            zooming: {
                type: 'xy' as const
            }
        },
        title: {
            text: title,
            align: 'left'
        },
        
        xAxis: {
            crosshair: true,
            accessibility: {
                description: ''
            },
            // minRange: 10,
            categories: categories,
            labels: {
                style: {
                    fontFamily: 'Trebuchet MS'
                }
            },
            title: {
                text: 'Products',
                style: {
                    fontFamily: 'Trebuchet MS'
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: 'Sales ($)',
                style: {
                    fontFamily: 'Trebuchet MS'
                }
            },
            labels: {
                formatter: function(this: Highcharts.AxisLabelsFormatterContextObject) {
                    const v = this.value as number;
                    const absv = Math.abs(v);
                    if (absv >= 1000000) return v / 1000000 + 'M';
                    if (absv >= 1000) return v / 1000 + 'K';
                    return String(v);
                },
                style: {
                    fontFamily: 'Trebuchet MS'
                }
            }
        },
        tooltip: {
            valueSuffix: ' ($)',
            formatter: function(this: Highcharts.Point) {
                return `<span style="font-family: Trebuchet MS;">${this.series.name}: ${formatNumber(this.y, 'en-US', 'USD')}</span>`;
            },
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0
            }
        },
        series: [
            {
                type: 'column',
                name: 'Current',
                data: currentSales
            },
            {
                type: 'column',
                name: 'Opportunity',
                data: modelSales
            }
        ]
    };

    return (
        <div style={{ height: '100%', width: '100%' }}>
            <HighchartsReact
                highcharts={Highcharts}
                options={options}
                allowChartUpdate={true}
                exportEnabled={true}
                ref={chartComponentRef}
                containerProps={{ style: { width: '100%', height: height, borderRadius: 5, boxShadow: 'none', margin: 0, padding: 0 } }}
            />
        </div>
    );
};

export default BarChart;
